import { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import TableFilter from '../../../common/TableFilter/TableFilter.jsx';

const ARCHIVE_STATUSES = ['active', 'archived'];

export const usePhdArchiveStatus = (storageKey) => {
  const [archiveStatus, setArchiveStatusState] = useState(() => {
    const stored =
      typeof window !== 'undefined'
        ? window.localStorage.getItem(storageKey)
        : null;
    return ARCHIVE_STATUSES.includes(stored) ? stored : 'active';
  });

  const setArchiveStatus = useCallback(
    (status) => {
      const normalized = ARCHIVE_STATUSES.includes(status) ? status : 'active';
      if (typeof window !== 'undefined') {
        window.localStorage.setItem(storageKey, normalized);
      }
      setArchiveStatusState(normalized);
    },
    [storageKey],
  );

  return { archiveStatus, setArchiveStatus };
};

const PhdArchiveFilter = ({ archiveStatus, onChange, storageKey }) => {
  const { t } = useTranslation();

  return (
    <>
      <TableFilter
        title={t('Zobrazenie záznamov')}
        storageKey={storageKey}
        value={archiveStatus}
        setValue={onChange}
        options={[
          { value: 'active', label: t('Aktívne') },
          { value: 'archived', label: t('Archív') },
        ]}
      />
      <Typography.Text type="secondary">
        {archiveStatus === 'active'
          ? t(
              'Aktívne zobrazenie obsahuje aktuálne záznamy. Možnosť ich úpravy závisí od oprávnení a stavu štúdia.',
            )
          : t(
              'Archív obsahuje uzavreté alebo historické záznamy. Sú iba na čítanie; dostupné zostáva prezeranie, tlač a povolený export.',
            )}
      </Typography.Text>
    </>
  );
};

PhdArchiveFilter.propTypes = {
  archiveStatus: PropTypes.oneOf(ARCHIVE_STATUSES).isRequired,
  onChange: PropTypes.func.isRequired,
  storageKey: PropTypes.string.isRequired,
};

export default PhdArchiveFilter;
